import * as React from 'react';

const cloneSet = <T>(oldSet: Set<T>): Set<T> => new Set([...oldSet]);

type AddRemoveFn = (key: string) => void;
export type ReplaceSet = (newSet: Set<string> | string[]) => void;

interface HookResult {
  addToSet: AddRemoveFn;
  removeFromSet: AddRemoveFn;
  set: Set<string>;
  replaceSet: ReplaceSet;
}

const isArray = (arrayOrSet: Array<string> | Set<string>): arrayOrSet is Array<string> => Array.isArray(arrayOrSet);

/**
 * A React state collection helper for a javascript Set
 */
const useStringSet = (initialStringSet: string[] = []): HookResult => {
  const dedupedInitializer = new Set(initialStringSet);
  const [stateValue, setStateValue] = React.useState(dedupedInitializer);

  const addToSet = React.useCallback<(...args: $TSFixMe[]) => $TSFixMe>((value: string) => {
    setStateValue((previousSet) => {
      const mutableSet = cloneSet(previousSet);
      mutableSet.add(value);
      return mutableSet;
    });
  }, []);

  const removeFromSet = React.useCallback<(...args: $TSFixMe[]) => $TSFixMe>((value: string) => {
    setStateValue((previousSet) => {
      const mutableSet = cloneSet(previousSet);
      mutableSet.delete(value);
      setStateValue(mutableSet);
      return mutableSet;
    });
  }, []);

  const replaceSet = React.useCallback<ReplaceSet>((incomingSet) => {
    if (isArray(incomingSet)) {
      setStateValue(new Set(incomingSet));
    } else {
      setStateValue(incomingSet);
    }
  }, []);

  return { addToSet, removeFromSet, set: stateValue, replaceSet };
};

export default useStringSet;
